"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.forceTouchedOnChange = forceTouchedOnChange;
var _react = _interopRequireWildcard(require("react"));
var _warning = _interopRequireDefault(require("cccisd-icons/warning2"));
var _cccisdTabs = _interopRequireDefault(require("cccisd-tabs"));
var _General = _interopRequireDefault(require("./General"));
var _Modules = _interopRequireDefault(require("./Modules"));
var _Pinned = _interopRequireDefault(require("./Pinned"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function forceTouchedOnChange(fieldProps) {
  var newOnChange = function newOnChange(event) {
    fieldProps.form.setFieldValue(fieldProps.field.name, event.target.value);
    fieldProps.form.setFieldTouched(fieldProps.field.name, true);
  };
  return {
    form: fieldProps.form,
    field: _objectSpread(_objectSpread({}, fieldProps.field), {}, {
      onChange: newOnChange
    })
  };
}
var WithModulesModalForm = function WithModulesModalForm(props) {
  var _formikBag$values;
  var formikBag = props.formikBag,
    getIsUnsavedChanges = props.getIsUnsavedChanges,
    isWithModulesUnsavedChanges = props.isWithModulesUnsavedChanges,
    setIsWithModulesUnsavedChanges = props.setIsWithModulesUnsavedChanges;
  var prefix = (formikBag === null || formikBag === void 0 ? void 0 : (_formikBag$values = formikBag.values) === null || _formikBag$values === void 0 ? void 0 : _formikBag$values.currentPrefix) || '';
  var errors = (formikBag === null || formikBag === void 0 ? void 0 : formikBag.errors) || {};
  (0, _react.useEffect)(function () {
    // AssignmentCard component needs this state hoisted
    // to know whether it needs to show Confirmation modal on close
    var isHighlightSave = getIsUnsavedChanges(formikBag);
    if (isHighlightSave !== isWithModulesUnsavedChanges) {
      setIsWithModulesUnsavedChanges(isHighlightSave);
    }
  }, [isWithModulesUnsavedChanges, formikBag]);
  var isErrorModules = false;
  var isErrorPinned = false;
  var isErrorGeneral = false;
  if (formikBag.submitCount > 0) {
    Object.keys(errors).forEach(function (k) {
      if (k.startsWith("".concat(prefix, ".modules")) && !!errors[k]) {
        isErrorModules = true;
      } else if (k.startsWith("".concat(prefix, ".pinnedContent")) && !!errors[k]) {
        isErrorPinned = true;
      } else if (errors[k]) {
        isErrorGeneral = true;
      }
    });
  }
  function renderTitle(title, hasError) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].tabTitle
    }, title, hasError && /*#__PURE__*/_react["default"].createElement(_warning["default"], null));
  }
  var tabList = [{
    name: 'modules',
    title: renderTitle('Modules & Lessons', isErrorModules),
    content: /*#__PURE__*/_react["default"].createElement(_Modules["default"], props)
  }, {
    name: 'pinned',
    title: renderTitle('Pinned Content', isErrorPinned),
    content: /*#__PURE__*/_react["default"].createElement(_Pinned["default"], props)
  }, {
    name: 'general',
    title: renderTitle('Settings', isErrorGeneral),
    content: /*#__PURE__*/_react["default"].createElement(_General["default"], props)
  }];
  return /*#__PURE__*/_react["default"].createElement(_cccisdTabs["default"], {
    tabList: tabList,
    orientation: "vertical"
  });
};
var _default = exports["default"] = WithModulesModalForm;